<template>
  <BusinessModuleEditor />
</template>

<script setup>
import BusinessModuleEditor from './BusinessModuleEditor.vue'
</script>
